/* KiseiCollect — comportements front, sans dépendance */
(function () {
  "use strict";

  /* ---------- menu mobile ---------- */
  function initBurger() {
    var burger = document.querySelector("[data-kc-burger]");
    var nav = document.querySelector("[data-kc-nav]");
    if (!burger || !nav) return;
    burger.addEventListener("click", function () {
      var open = nav.classList.toggle("is-open");
      burger.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  /* ---------- sélecteur de quantité ---------- */
  function initQty(root) {
    (root || document).querySelectorAll("[data-kc-qty]").forEach(function (widget) {
      if (widget.dataset.kcQtyReady) return;
      widget.dataset.kcQtyReady = "1";
      var input = widget.querySelector("input");
      if (!input) return;

      function borne(nom, defaut) {
        var v = parseInt(input.getAttribute(nom), 10);
        return isNaN(v) ? defaut : v;
      }

      /* Grise le bouton devenu inutile : sans ça on clique dans le vide
         quand le stock est atteint, sans comprendre pourquoi. */
      function majBoutons() {
        var val = parseInt(input.value, 10);
        if (isNaN(val)) val = borne("min", 1);
        widget.querySelectorAll("[data-kc-qty-step]").forEach(function (b) {
          var pas = parseInt(b.dataset.kcQtyStep, 10) || 1;
          var bloque = pas > 0
            ? (input.hasAttribute("max") && val >= borne("max", Infinity))
            : val <= borne("min", 1);
          b.disabled = bloque;
          b.setAttribute("aria-disabled", bloque ? "true" : "false");
        });
      }

      widget.querySelectorAll("[data-kc-qty-step]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var step = parseInt(btn.dataset.kcQtyStep, 10) || 1;
          var min = borne("min", 1);
          var next = (parseInt(input.value, 10) || min) + step;
          if (next < min) next = min;
          if (input.hasAttribute("max")) {
            var max = borne("max", Infinity);
            if (next > max) next = max;
          }
          if (String(next) === input.value) return;   // rien n'a bouge
          input.value = next;
          majBoutons();
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      });

      input.addEventListener("input", majBoutons);
      majBoutons();
    });
  }

  /* ---------- panier : la quantité soumet la ligne ---------- */
  function initCartAutoSubmit() {
    var form = document.querySelector("#kc-cart-form");
    if (!form) return;
    form.addEventListener("change", function (e) {
      if (e.target.matches("[data-kc-cart-qty]")) form.submit();
    });
  }

  /* ---------- panier : quantite au-dela du stock ----------
     Le navigateur bloque deja la commande, mais avec sa propre bulle
     (« Cette valeur doit etre inferieure ou egale a 1 »), dans la langue du
     systeme et hors charte. On la coupe et on dit la meme chose dans la ligne
     concernee, avec de quoi corriger en un clic. */
  function initCartStock(root) {
    var sobre = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var dernierRecale = 0;

    (root || document).querySelectorAll("[data-kc-cart-qty]").forEach(function (input) {
      if (input.dataset.kcStockReady) return;
      input.dataset.kcStockReady = "1";

      var ligne = input.closest(".kc-line");
      var alerte = ligne && ligne.querySelector("[data-kc-line-alerte]");
      var max = parseInt(input.getAttribute("max"), 10);
      if (!alerte || isNaN(max)) return;

      function verifier() {
        var val = parseInt(input.value, 10);
        alerte.hidden = isNaN(val) || val <= max;
      }

      /* Sans la bulle native, plus rien n'amene l'oeil au champ fautif :
         on s'en charge, une seule fois par tentative d'envoi. */
      input.addEventListener("invalid", function (e) {
        e.preventDefault();
        verifier();
        var t = Date.now();
        if (t - dernierRecale < 400) return;
        dernierRecale = t;
        ligne.scrollIntoView({ block: "center", behavior: sobre ? "auto" : "smooth" });
        input.focus({ preventScroll: true });
      });

      input.addEventListener("input", verifier);

      var fix = alerte.querySelector("[data-kc-line-fix]");
      if (fix) {
        fix.addEventListener("click", function () {
          input.value = fix.dataset.kcLineFix;
          input.dispatchEvent(new Event("input", { bubbles: true }));
          input.dispatchEvent(new Event("change", { bubbles: true }));   // met le panier a jour
        });
      }

      verifier();   /* le panier peut deja depasser le stock au chargement */
    });
  }

  /* ---------- suggestions de recherche ----------
     Shopify rend la section predictive-search a la demande et on injecte le
     fragment tel quel : prix, traductions et libelles de stock restent ceux du
     theme, sans les reconstruire en JS. Sans JS le formulaire part sur /search
     comme avant, la fonctionnalite est un supplement. */
  function initPredictiveSearch() {
    if (!window.fetch || !window.DOMParser) return;

    document.querySelectorAll("[data-kc-search]").forEach(function (form) {
      if (form.dataset.kcSearchReady) return;
      form.dataset.kcSearchReady = "1";

      var champ = form.querySelector("[data-kc-search-input]");
      var boite = form.querySelector("[data-kc-sugg]");
      if (!champ || !boite) return;

      var MINI = 2;                 /* une lettre renvoie tout le catalogue */
      var attente, enCours, demande = "";
      var cache = Object.create(null);
      var actif = -1;

      function options() {
        return Array.prototype.slice.call(boite.querySelectorAll("[role='option']"));
      }

      function fermer() {
        boite.hidden = true;
        boite.innerHTML = "";
        champ.setAttribute("aria-expanded", "false");
        champ.removeAttribute("aria-activedescendant");
        actif = -1;
      }

      function afficher(html) {
        boite.innerHTML = html;
        boite.hidden = false;
        champ.setAttribute("aria-expanded", "true");
        champ.removeAttribute("aria-activedescendant");
        actif = -1;
      }

      /* Le champ garde le focus : c'est lui qui porte aria-activedescendant,
         et les liens sont en tabindex="-1" pour rester hors du parcours Tab. */
      function surligner(i) {
        var liste = options();
        if (!liste.length) return;
        if (i < 0) i = liste.length - 1;
        if (i >= liste.length) i = 0;
        liste.forEach(function (o, k) {
          o.classList.toggle("is-on", k === i);
          o.setAttribute("aria-selected", k === i ? "true" : "false");
        });
        actif = i;
        champ.setAttribute("aria-activedescendant", liste[i].id);
        liste[i].scrollIntoView({ block: "nearest" });
      }

      function chercher(q) {
        if (cache[q]) { afficher(cache[q]); return; }
        if (enCours) enCours.abort();
        enCours = typeof AbortController === "function" ? new AbortController() : null;

        if (boite.hidden) {
          afficher('<p class="kc-sugg__attente">' + (boite.dataset.kcSuggAttente || "") + "</p>");
        }

        fetch("/search/suggest?q=" + encodeURIComponent(q) +
              "&section_id=predictive-search" +
              "&resources[type]=product,collection,article" +
              "&resources[limit]=6&resources[limit_scope]=each",
              enCours ? { signal: enCours.signal } : undefined)
          .then(function (r) {
            if (!r.ok) throw new Error(r.status);
            return r.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, "text/html");
            var bloc = doc.getElementById("shopify-section-predictive-search") || doc.body;
            cache[q] = bloc.innerHTML.trim();
            /* la reponse peut arriver apres que l'utilisateur a continue a taper */
            if (champ.value.trim() !== q) return;
            if (cache[q]) afficher(cache[q]); else fermer();
          })
          .catch(function (e) {
            if (!e || e.name !== "AbortError") fermer();
          });
      }

      champ.addEventListener("input", function () {
        var q = champ.value.trim();
        clearTimeout(attente);
        if (q.length < MINI) { demande = ""; fermer(); return; }
        if (q === demande) return;
        demande = q;
        attente = setTimeout(function () { chercher(q); }, 220);
      });

      champ.addEventListener("keydown", function (e) {
        if (e.key === "Escape") { clearTimeout(attente); demande = ""; fermer(); return; }
        if (boite.hidden) return;
        if (e.key === "ArrowDown") { e.preventDefault(); surligner(actif + 1); }
        else if (e.key === "ArrowUp") { e.preventDefault(); surligner(actif - 1); }
        else if (e.key === "Enter" && actif > -1) {
          var lien = options()[actif].querySelector("a");
          if (lien) { e.preventDefault(); window.location.href = lien.href; }
        }
      });

      champ.addEventListener("focus", function () {
        var q = champ.value.trim();
        if (q.length >= MINI && cache[q]) afficher(cache[q]);
      });

      /* Sans ca le clic sur un resultat sort le focus du champ, ce qui ferme
         le panneau avant que le lien ne soit suivi. */
      boite.addEventListener("mousedown", function (e) { e.preventDefault(); });

      form.addEventListener("focusout", function (e) {
        if (!form.contains(e.relatedTarget)) fermer();
      });
      document.addEventListener("click", function (e) {
        if (!form.contains(e.target)) fermer();
      });
    });
  }

  /* ---------- bandeau cookies ----------
     Le bandeau natif de Shopify est desactive dans l'admin : c'est celui-ci qui
     recueille le consentement, via la Customer Privacy API. Les quatre signaux
     (analytics, marketing, preferences, sale_of_data) sont ceux que Shopify
     applique ensuite a ses pixels, a ses audiences et au checkout.

     Rien ne s'affiche tant que l'API n'a pas repondu : si elle est absente, le
     bandeau reste cache et le bouton du pied de page aussi. Mieux vaut pas de
     bandeau qu'un bandeau qui ne consigne rien. */
  function initCookieBanner() {
    var racine = document.querySelector("[data-kc-cookies]");
    if (!racine || !window.Shopify || !window.Shopify.loadFeatures) return;
    if (racine.dataset.kcCookiesReady) return;
    racine.dataset.kcCookiesReady = "1";

    window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (err) {
      if (err || !window.Shopify.customerPrivacy) return;

      var api = window.Shopify.customerPrivacy;
      var ouvreur = document.querySelector("[data-kc-cookies-open]");
      var reglages = racine.querySelector("[data-kc-cookies-reglages]");
      var bascule = racine.querySelector("[data-kc-cookies-toggle]");
      var garder = racine.querySelector("[data-kc-cookies-save]");
      var echec = racine.querySelector("[data-kc-cookies-echec]");
      var sobre = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      var cases = {};
      racine.querySelectorAll("[data-kc-consent]").forEach(function (b) {
        cases[b.dataset.kcConsent] = b;
      });

      /* currentVisitorConsent() rend "yes" / "no" / "" selon les versions */
      function oui(v) { return v === true || v === "yes"; }
      function tranche(v) { return v === true || v === false || v === "yes" || v === "no"; }

      /* shouldShowBanner() ne dit que si la region du visiteur demande un
         bandeau : il reste vrai en France meme apres un choix, sur la page du
         choix comme sur les suivantes (constate en ligne le 22/09/2026). Le
         choix deja fait se lit dans currentVisitorConsent() : "" tant que le
         visiteur n'a pas repondu, "yes" ou "no" ensuite. */
      function choixFait() {
        var c = {};
        try { c = api.currentVisitorConsent() || {}; } catch (e) { return false; }
        return ["analytics", "marketing", "preferences"].some(function (k) { return tranche(c[k]); });
      }

      function prefiller() {
        var c = {};
        try { c = api.currentVisitorConsent() || {}; } catch (e) { c = {}; }
        Object.keys(cases).forEach(function (k) { cases[k].checked = oui(c[k]); });
      }

      function replier() {
        if (reglages) reglages.hidden = true;
        if (garder) garder.hidden = true;
        if (bascule) bascule.setAttribute("aria-expanded", "false");
      }

      function afficher() {
        prefiller();
        racine.hidden = false;
        /* Force le calcul du style avant de basculer la classe, sinon la
           transition est sautee. requestAnimationFrame ne convient pas : il ne
           se declenche pas dans un onglet en arriere-plan, et le bandeau
           resterait alors a opacity:0 jusqu'au retour du visiteur. */
        void racine.offsetWidth;
        racine.classList.add("is-on");
      }

      function fermer() {
        racine.classList.remove("is-on");
        setTimeout(function () { racine.hidden = true; replier(); }, sobre ? 0 : 280);
      }

      /* sale_of_data suit le marketing : c'est le choix le plus protecteur,
         on ne partage pas les donnees de qui a refuse la publicite.

         On ne ferme qu'une fois le choix reellement consigne, c'est-a-dire relu
         a l'identique dans currentVisitorConsent(). */
      function repondre(c) {
        var fini = false;

        function conclure(ok, pourquoi) {
          if (fini) return;
          fini = true;
          if (ok) { if (echec) echec.hidden = true; fermer(); return; }
          console.warn("[kc] consentement non enregistre", pourquoi);
          if (echec) echec.hidden = false;
        }

        /* Si le rappel ne vient jamais, on ferme quand meme : mieux vaut un
           bandeau qui revient qu'un visiteur bloque devant un bouton inerte. */
        var secours = setTimeout(function () { conclure(true); }, 1500);

        try {
          api.setTrackingConsent({
            analytics: !!c.analytics,
            marketing: !!c.marketing,
            preferences: !!c.preferences,
            sale_of_data: !!c.marketing
          }, function (res) {
            clearTimeout(secours);
            if (res && res.error) return conclure(false, res.error);
            var lu = {};
            try { lu = api.currentVisitorConsent() || {}; } catch (e) { lu = {}; }
            var ok = ["analytics", "marketing", "preferences"].every(function (k) {
              return tranche(lu[k]) && oui(lu[k]) === !!c[k];
            });
            conclure(ok, ok ? null : "choix non relu : " + JSON.stringify(lu));
          });
        } catch (e) {
          clearTimeout(secours);
          conclure(false, e);
        }
      }

      var accepter = racine.querySelector("[data-kc-cookies-accept]");
      var refuser = racine.querySelector("[data-kc-cookies-reject]");
      if (accepter) accepter.addEventListener("click", function () {
        repondre({ analytics: true, marketing: true, preferences: true });
      });
      if (refuser) refuser.addEventListener("click", function () {
        repondre({ analytics: false, marketing: false, preferences: false });
      });
      if (garder) garder.addEventListener("click", function () {
        repondre({
          analytics: !!(cases.analytics && cases.analytics.checked),
          marketing: !!(cases.marketing && cases.marketing.checked),
          preferences: !!(cases.preferences && cases.preferences.checked)
        });
      });

      if (bascule) bascule.addEventListener("click", function () {
        var ouvert = bascule.getAttribute("aria-expanded") === "true";
        bascule.setAttribute("aria-expanded", ouvert ? "false" : "true");
        if (reglages) reglages.hidden = ouvert;
        if (garder) garder.hidden = ouvert;
        if (!ouvert && cases.analytics) cases.analytics.focus();
      });

      /* Revenir sur son choix : c'est la condition d'un consentement valable. */
      if (ouvreur) {
        ouvreur.hidden = false;
        ouvreur.addEventListener("click", function () {
          afficher();
          if (bascule && bascule.getAttribute("aria-expanded") !== "true") bascule.click();
        });
      }

      var doit = false;
      try { doit = api.shouldShowBanner() && !choixFait(); } catch (e) { doit = false; }
      if (doit) afficher();
    });
  }

  /* ---------- galerie produit : vignettes ---------- */
  function initGallery() {
    var gallery = document.querySelector("[data-kc-gallery]");
    if (!gallery) return;
    var flat = gallery.querySelector("[data-kc-stage-flat]");
    var flatImg = flat ? flat.querySelector("img") : null;
    if (!flat || !flatImg) return;

    gallery.querySelectorAll("[data-kc-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        gallery.querySelectorAll("[data-kc-thumb]").forEach(function (t) {
          t.classList.toggle("is-on", t === thumb);
        });
        var src = thumb.dataset.kcThumb;
        if (!src) return;
        flatImg.src = src;
        flatImg.alt = thumb.dataset.kcThumbAlt || "";
      });
    });
  }

  /* ---------- compte à rebours du drop ---------- */
  /* Vitrine des séries : le projecteur de la colonne survolée suit le pointeur.
     Sans souris fine, ou en mouvement réduit, il reste centré. */
  function initSeriesLight() {
    var root = document.querySelector("[data-kc-series]");
    if (!root || root.dataset.kcLight) return;
    root.dataset.kcLight = "1";
    if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    var last = null;
    root.addEventListener("pointermove", function (e) {
      var col = e.target.closest(".kc-serie");
      if (last && last !== col) last.style.removeProperty("--kc-lx");
      last = col;
      if (!col) return;
      var r = col.getBoundingClientRect();
      var x = Math.min(Math.max((e.clientX - r.left) / r.width, 0.22), 0.78);
      col.style.setProperty("--kc-lx", (x * 100).toFixed(1) + "%");
    });
    root.addEventListener("pointerleave", function () {
      if (last) last.style.removeProperty("--kc-lx");
      last = null;
    });
  }

  function initCountdown() {
    document.querySelectorAll("[data-kc-countdown]").forEach(function (el) {
      var target = Date.parse(el.dataset.kcCountdown);
      if (isNaN(target)) return;
      var cells = {
        days: el.querySelector("[data-kc-cd-days]"),
        hours: el.querySelector("[data-kc-cd-hours]"),
        minutes: el.querySelector("[data-kc-cd-minutes]")
      };
      var live = el.querySelector("[data-kc-cd-live]");
      var pad = function (n) { return n < 10 ? "0" + n : String(n); };

      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) {
          if (cells.days) cells.days.textContent = "00";
          if (cells.hours) cells.hours.textContent = "00";
          if (cells.minutes) cells.minutes.textContent = "00";
          if (live) live.hidden = false;
          clearInterval(timer);
          return;
        }
        var mins = Math.floor(diff / 60000);
        if (cells.days) cells.days.textContent = pad(Math.floor(mins / 1440));
        if (cells.hours) cells.hours.textContent = pad(Math.floor((mins % 1440) / 60));
        if (cells.minutes) cells.minutes.textContent = pad(mins % 60);
      }

      tick();
      var timer = setInterval(tick, 30000);
    });
  }

  /* ---------- onglets du compte client ---------- */
  function initTabs() {
    var root = document.querySelector("[data-kc-tabs]");
    if (!root) return;
    var links = Array.prototype.slice.call(root.querySelectorAll("[data-kc-tab]"));
    var panels = Array.prototype.slice.call(root.querySelectorAll("[data-kc-panel]"));
    if (!links.length || !panels.length) return;

    function show(id) {
      panels.forEach(function (p) { p.hidden = p.id !== id; });
      links.forEach(function (l) { l.classList.toggle("is-on", l.dataset.kcTab === id); });
    }

    links.forEach(function (link) {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        show(link.dataset.kcTab);
        if (history.replaceState) history.replaceState(null, "", "#" + link.dataset.kcTab);
      });
    });

    var initial = window.location.hash.replace("#", "");
    show(links.some(function (l) { return l.dataset.kcTab === initial; }) ? initial : links[0].dataset.kcTab);
  }

  /* ---------- préférences d'alertes ----------
     L'état est mémorisé localement pour l'affichage, et les cases cochées
     alimentent le champ contact[tags] envoyé à Shopify au moment de l'envoi. */
  function initAlertPrefs() {
    var root = document.querySelector("[data-kc-alerts]");
    if (!root) return;
    var KEY = "kc:alert-prefs";
    var saved = {};
    try { saved = JSON.parse(localStorage.getItem(KEY) || "{}") || {}; } catch (e) { saved = {}; }

    var boxes = Array.prototype.slice.call(root.querySelectorAll("input[type=checkbox][data-kc-alert]"));
    var tagField = document.querySelector("[data-kc-alert-tags]");

    function syncTags() {
      if (!tagField) return;
      tagField.value = boxes
        .filter(function (b) { return b.checked; })
        .map(function (b) { return b.dataset.kcAlert; })
        .join(",");
    }

    boxes.forEach(function (input) {
      var id = input.dataset.kcAlert;
      if (Object.prototype.hasOwnProperty.call(saved, id)) input.checked = !!saved[id];
      input.addEventListener("change", function () {
        saved[id] = input.checked;
        try { localStorage.setItem(KEY, JSON.stringify(saved)); } catch (e) { /* stockage indisponible */ }
        syncTags();
      });
    });

    syncTags();
  }

  /* ---------- présélection du pays sur les adresses ----------
     {{ country_option_tags }} présélectionne le pays de la boutique ;
     on rétablit celui de l'adresse enregistrée. */
  function initAddressCountry() {
    document.querySelectorAll("select[data-default]").forEach(function (select) {
      var wanted = select.dataset.default;
      if (!wanted) return;
      var match = Array.prototype.slice.call(select.options).some(function (o) { return o.value === wanted; });
      if (match) select.value = wanted;
    });
  }

  /* ---------- ouverture de booster ---------- */
  function initBooster() {
    var racine = document.querySelector("[data-kc-booster]");
    var ouvrir = document.querySelector("[data-kc-booster-open]");
    if (!racine || !ouvrir || racine.dataset.kcBoosterReady) return;
    racine.dataset.kcBoosterReady = "1";

    var pack = racine.querySelector("[data-kc-pack]");
    var art = racine.querySelector("[data-kc-pack-art]");
    var choix = Array.prototype.slice.call(racine.querySelectorAll("[data-kc-pick]"));
    var reserve = Array.prototype.slice.call(racine.querySelectorAll("[data-kc-card]"));
    var cartes = [];   /* les 10 cartes tirees pour l ouverture en cours */
    var PAR_BOOSTER = 10;
    var indice = 0;
    var etape = "choose";
    var minuteries = [];
    var sobre = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    var hint = racine.querySelector("[data-kc-booster-hint]");
    var fini = racine.querySelector("[data-kc-booster-done]");
    var etiquette = racine.querySelector("[data-kc-card-label]");

    function poser(ms, fn) { minuteries.push(setTimeout(fn, sobre ? 0 : ms)); }
    function vider() { minuteries.forEach(clearTimeout); minuteries = []; }

    function melanger(t) {
      for (var i = t.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = t[i]; t[i] = t[j]; t[j] = tmp;
      }
      return t;
    }

    /* Tire au sort le contenu du booster, dans l'extension du booster choisi quand la reserve
       en melange plusieurs. Comme un vrai : une carte rare (deux, une fois sur cinq), placee
       au centre, et des courantes. Les images se chargent des le tirage, avant l'ouverture. */
    var serie = "";
    function tirer() {
      var pioche = reserve.filter(function (c) { return !serie || c.dataset.kcSerie === serie; });
      if (!pioche.length) pioche = reserve.slice();
      var estRare = function (c) { return c.classList.contains("kc-card--rare"); };
      var rares = melanger(pioche.filter(estRare));
      var courantes = melanger(pioche.filter(function (c) { return !estRare(c); }));
      var nbRares = Math.min(rares.length, Math.random() < 0.2 ? 2 : 1);
      /* courantes d'abord ; les rares restantes ne servent que si les courantes manquent */
      var autres = courantes.concat(rares.slice(nbRares)).slice(0, PAR_BOOSTER - nbRares);
      cartes = melanger(autres.concat(rares.slice(1, nbRares)));
      if (nbRares) cartes.splice(Math.floor((cartes.length + 1) / 2), 0, rares[0]);
      reserve.forEach(function (c) { c.hidden = cartes.indexOf(c) === -1; });
      cartes.forEach(function (c) { var img = c.querySelector("img"); if (img) img.loading = "eager"; });
      indice = Math.floor(cartes.length / 2);
    }

    /* Place chaque carte : la centrale en avant, les autres en éventail */
    function disposer() {
      var deploye = etape === "burst" || etape === "carousel";
      cartes.forEach(function (carte, i) {
        var ecart = i - indice;
        var dist = Math.abs(ecart);
        var centre = ecart === 0;
        carte.classList.toggle("is-current", centre && deploye);
        if (!deploye) {
          carte.style.transform = "translate(-50%,-50%) translateY(26px) scale(.8)";
          carte.style.opacity = "0";
          carte.style.pointerEvents = "none";
          carte.style.transitionDelay = "0ms";
          return;
        }
        var retard = etape === "burst" ? Math.min(dist, 4) * 110 : 0;
        carte.style.transitionDelay = retard + "ms";
        carte.style.transform =
          "translate(-50%,-50%) translate(" + ecart * 118 + "px," + (centre ? -86 : -56 + dist * 5) + "px)" +
          " rotate(" + ecart * 3 + "deg) scale(" + (centre ? 1.2 : Math.max(0.76, 0.9 - dist * 0.05)) + ")";
        carte.style.opacity = dist > 4 ? "0" : "1";
        carte.style.pointerEvents = dist > 4 ? "none" : "auto";
        carte.style.zIndex = String(30 - dist);
      });
      if (etiquette && deploye && cartes[indice]) {
        etiquette.textContent = (cartes[indice].getAttribute("aria-label") || "") +
          "  ·  " + (indice + 1) + " / " + cartes.length;
      }
    }

    function etat(nouvel) {
      etape = nouvel;
      racine.dataset.kcStage = nouvel;
      if (hint) hint.hidden = nouvel !== "idle";
      if (fini) fini.hidden = nouvel !== "burst" && nouvel !== "carousel";
      disposer();
    }

    /* Le booster choisi devient celui qu'on ouvre */
    function choisir(bouton) {
      serie = bouton.dataset.kcSerie || "";
      if (art) {
        art.src = bouton.dataset.kcPick;
        art.alt = bouton.getAttribute("aria-label") || "";
      }
      tirer();
      etat("idle");
      pack.focus();
    }

    function ouvrirPack() {
      if (etape !== "idle") return;
      if (!cartes.length) tirer();
      etat("tear");
      poser(620, function () { etat("burst"); });
      poser(2100, function () { etat("carousel"); });
    }

    /* Retour au choix du booster, ou à l'état initial s'il n'y en a qu'un */
    function recommencer() {
      vider();
      reserve.forEach(function (c) { c.hidden = true; });
      cartes = [];
      indice = 0;
      etat(choix.length ? "choose" : "idle");
    }

    function afficher() {
      racine.hidden = false;
      document.body.style.overflow = "hidden";
      recommencer();
      (choix.length ? choix[0] : pack).focus();
      document.addEventListener("keydown", auClavier);
    }

    function fermer() {
      vider();
      racine.hidden = true;
      document.body.style.overflow = "";
      document.removeEventListener("keydown", auClavier);
      ouvrir.focus();
    }

    function auClavier(e) {
      if (e.key === "Escape") fermer();
      else if (e.key === "ArrowRight") deplacer(1);
      else if (e.key === "ArrowLeft") deplacer(-1);
    }

    function deplacer(pas) {
      if (etape !== "burst" && etape !== "carousel") return;
      indice = Math.max(0, Math.min(cartes.length - 1, indice + pas));
      disposer();
    }

    /* les visuels des boosters se chargent des que le bouton est survole ou touche */
    function precharger() {
      choix.forEach(function (b) { var img = b.querySelector("img"); if (img) img.loading = "eager"; });
    }
    ouvrir.addEventListener("pointerenter", precharger, { once: true });
    ouvrir.addEventListener("focus", precharger, { once: true });
    ouvrir.addEventListener("click", afficher);
    pack.addEventListener("click", ouvrirPack);
    choix.forEach(function (b) { b.addEventListener("click", function () { choisir(b); }); });
    racine.querySelectorAll("[data-kc-booster-close]").forEach(function (b) {
      b.addEventListener("click", fermer);
    });
    var reset = racine.querySelector("[data-kc-booster-reset]");
    if (reset) reset.addEventListener("click", recommencer);
    var prec = racine.querySelector("[data-kc-card-prev]");
    var suiv = racine.querySelector("[data-kc-card-next]");
    if (prec) prec.addEventListener("click", function () { deplacer(-1); });
    if (suiv) suiv.addEventListener("click", function () { deplacer(1); });
    /* une carte de l'eventail, cliquee, passe au centre (les cartes tirees changent a chaque ouverture) */
    reserve.forEach(function (carte) {
      carte.addEventListener("click", function () {
        var i = cartes.indexOf(carte);
        if (i > -1 && (etape === "burst" || etape === "carousel")) { indice = i; disposer(); }
      });
    });

    etat(choix.length ? "choose" : "idle");
  }

  /* ---------- tri et filtres de collection ----------
     Un seul formulaire (sections/main-collection.liquid) porte le tri et les
     filtres de l'app Search & Discovery. Cocher une case, changer le tri ou
     valider un prix recharge la section seule (Section Rendering API) : la
     grille change sans quitter la page, le menu ouvert le reste, l'adresse
     suit, retour arriere compris. Au moindre echec, on charge la page. */
  var kcFiltresDoc = false;
  var kcFiltresRequete = null;

  function kcCollection() {
    return document.querySelector("[data-kc-collection]");
  }

  function kcFermerFiltres(racine, sauf) {
    racine.querySelectorAll("[data-kc-filtre][open]").forEach(function (d) {
      if (d !== sauf) d.removeAttribute("open");
    });
  }

  /* Adresse de la vue demandee : champs remplis seulement, tri par defaut omis. */
  function kcAdresseFiltres(form) {
    var params = new URLSearchParams();
    var tri = form.querySelector("[name='sort_by']");
    var defaut = tri && tri.getAttribute("data-kc-tri-defaut");
    new FormData(form).forEach(function (v, k) {
      v = String(v).trim();
      if (v === "" || (k === "sort_by" && v === defaut)) return;
      params.append(k, v);
    });
    var q = params.toString();
    return form.getAttribute("action") + (q ? "?" + q : "");
  }

  /* repli : ou poser le focus si l'element actif disparait avec l'ancien rendu */
  function kcChargerCollection(url, historique, focusRepli) {
    var racine = kcCollection();
    var sectionId = racine && racine.getAttribute("data-section-id");
    if (!sectionId || !window.fetch || typeof URL !== "function") { window.location.assign(url); return; }
    if (kcFiltresRequete) kcFiltresRequete.abort();
    var ctrl = typeof AbortController === "function" ? new AbortController() : { abort: function () {} };
    kcFiltresRequete = ctrl;

    /* ce qu'il faut retrouver apres le remplacement : le menu ouvert, le champ actif */
    var ouvert = racine.querySelector("[data-kc-filtre][open]");
    var cleOuverte = ouvert && ouvert.getAttribute("data-kc-filtre");
    var actif = document.activeElement;
    var idActif = actif && racine.contains(actif) && actif.id ? actif.id : null;

    var cible = new URL(url, window.location.href);
    cible.searchParams.set("section_id", sectionId);
    racine.setAttribute("aria-busy", "true");

    fetch(cible.toString(), { signal: ctrl.signal, credentials: "same-origin" })
      .then(function (r) {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.text();
      })
      .then(function (html) {
        var neuf = kcExtraire(html, "[data-kc-collection]");
        if (!neuf) throw new Error("section introuvable");
        racine.innerHTML = neuf.innerHTML;
        if (cleOuverte) {
          var d = racine.querySelector("[data-kc-filtre='" + cleOuverte + "']");
          if (d) d.setAttribute("open", "");
        }
        var champ = idActif && document.getElementById(idActif);
        /* repli par ordre de preference, pas par ordre du document */
        (focusRepli || "").split(",").forEach(function (sel) {
          if (!champ && sel.trim()) champ = racine.querySelector(sel.trim());
        });
        if (champ) champ.focus({ preventScroll: true });
        if (historique) window.history.pushState({ kcFiltres: true }, "", url);
        var annonce = document.querySelector("[data-kc-annonce]");
        var compte = racine.querySelector("[data-kc-compte]");
        if (annonce && compte) annonce.textContent = compte.textContent.replace(/\s+/g, " ").trim();
      })
      .catch(function (err) {
        if (err && err.name === "AbortError") return;
        window.location.assign(url);
      })
      .then(function () {
        if (kcFiltresRequete !== ctrl) return;
        kcFiltresRequete = null;
        racine.removeAttribute("aria-busy");
      });
  }

  function initFiltres() {
    var racine = kcCollection();
    if (!racine || racine.hasAttribute("data-kc-filtres-prets")) return;
    racine.setAttribute("data-kc-filtres-prets", "");

    racine.addEventListener("change", function (e) {
      var form = e.target.form;
      if (!form || !form.hasAttribute("data-kc-filtres-form")) return;
      /* filtre exclusif (disponibilite) : une seule case cochee a la fois */
      var groupe = e.target.checked && e.target.closest("[data-kc-exclusif]");
      if (groupe) {
        groupe.querySelectorAll("input[type='checkbox']").forEach(function (c) {
          if (c !== e.target) c.checked = false;
        });
      }
      if (e.target.matches("input[type='checkbox'], select")) kcChargerCollection(kcAdresseFiltres(form), true);
    });

    /* Entree dans un champ de prix, ou « Appliquer » */
    racine.addEventListener("submit", function (e) {
      var form = e.target;
      if (!form.hasAttribute("data-kc-filtres-form")) return;
      e.preventDefault();
      var bornes = form.querySelectorAll(".kc-prix__saisie");
      if (bornes.length === 2 && bornes[0].value !== "" && bornes[1].value !== "" &&
          Number(bornes[0].value) > Number(bornes[1].value)) {
        var t = bornes[0].value;
        bornes[0].value = bornes[1].value;
        bornes[1].value = t;
      }
      kcChargerCollection(kcAdresseFiltres(form), true);
    });

    /* pastilles « retirer » et « Tout effacer » */
    racine.addEventListener("click", function (e) {
      var lien = e.target.closest && e.target.closest("[data-kc-filtre-lien]");
      if (!lien || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      /* la pastille cliquee disparait : on passe a la suivante, sinon au premier filtre */
      kcChargerCollection(lien.href, true, ".kc-filtres__actifs .kc-pastille, .kc-filtres__effacer, .kc-filtre__bouton");
    });

    /* un seul menu ouvert a la fois ; « toggle » ne remonte pas, d'ou la capture */
    racine.addEventListener("toggle", function (e) {
      if (e.target.matches && e.target.matches("[data-kc-filtre]") && e.target.open) kcFermerFiltres(racine, e.target);
    }, true);

    if (kcFiltresDoc) return;
    kcFiltresDoc = true;
    document.addEventListener("click", function (e) {
      var r = kcCollection();
      if (r && !(e.target.closest && e.target.closest("[data-kc-filtre]"))) kcFermerFiltres(r, null);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      var r = kcCollection();
      var d = r && r.querySelector("[data-kc-filtre][open]");
      if (!d) return;
      d.removeAttribute("open");
      var s = d.querySelector("summary");
      if (s) s.focus();
    });
    window.addEventListener("popstate", function () {
      if (kcCollection()) kcChargerCollection(window.location.pathname + window.location.search, false);
    });
  }

  /* ---------- ajout au panier ----------
     Sans JS le formulaire part en POST classique et Shopify redirige : le
     comportement reste entier. Avec JS on reste sur la fiche, et l'article
     est vu « tomber » dans la pastille panier de l'en-tete. Si la fiche
     porte les fenetres de snippets/cart-popups.liquid, la confirmation s'y
     affiche ; sinon, dans la note sous le bouton. */

  var KC_COCHE =
    '<svg class="kc-coche" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" focusable="false">' +
    '<path d="M2.5 7.4 5.4 10.3 11.5 3.9" fill="none" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function kcRacine() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return r || "/";
  }

  /* Extrait un noeud d'une section rendue par Shopify. Une <div> du document
     plutot qu'un DOMParser : les images commencent a charger avant meme que
     la fenetre ne s'ouvre. */
  function kcExtraire(html, selecteur) {
    var boite = document.createElement("div");
    boite.innerHTML = html;
    return boite.querySelector(selecteur);
  }

  /* Page figee sous une fenetre ; la largeur de la barre de defilement est
     rendue en marge, sinon la page saute d'un cran vers la droite. Deja
     figee (relais d'une fenetre a l'autre), on ne remesure pas : la barre
     a disparu et la mesure vaudrait zero. */
  function kcVerrou(actif) {
    var corps = document.body;
    if (actif) {
      if (corps.hasAttribute("data-kc-verrou")) return;
      var barre = window.innerWidth - document.documentElement.clientWidth;
      corps.setAttribute("data-kc-verrou", "");
      if (barre > 0) corps.style.paddingRight = barre + "px";
      corps.style.overflow = "hidden";
    } else {
      corps.removeAttribute("data-kc-verrou");
      corps.style.paddingRight = "";
      corps.style.overflow = "";
    }
  }

  /* ---------- fenetres apres ajout ----------
     1. « Ajoute au panier » : corps rendu par Shopify dans la reponse meme
        de /cart/add.js (parametre `sections`), panier deja a jour.
     2. Suggestions : intercalees quand l'acheteur part vers le panier ou la
        commande, une fois par session, et seulement s'il y a quelque chose
        a proposer. « Continuer » l'emmene la ou il allait. */
  function initCartPopups(opts) {
    var ajout = document.querySelector("[data-kc-pop='added']");
    if (!ajout || typeof ajout.showModal !== "function") return null;
    var sugg = document.querySelector("[data-kc-pop='suggest']");
    var slot = ajout.querySelector("[data-kc-pop-slot]");
    var pret = null;      /* suggestions pretes a montrer, ou null */
    var demande = 0;      /* numero de la derniere demande de suggestions */
    var cap = "cart";     /* ou allait l'acheteur : "cart" ou "checkout" */

    function ouvrir(d) {
      kcVerrou(true);
      d.showModal();
    }

    [ajout, sugg].forEach(function (d) {
      if (!d) return;
      var appuiSurVoile = false;
      d.addEventListener("close", function () {
        if (document.querySelector("dialog.kc-pop[open]")) return;   /* relais : l'autre prend la main */
        kcVerrou(false);
        /* Le focus natif revient a l'element qui l'avait avant l'ouverture ;
           ici personne : le bouton d'ajout, desactive le temps de la requete,
           l'avait perdu. Au moment de cet evenement, Chrome le laisse encore
           dans la fenetre fermee, et ne le lache sur la page qu'ensuite. */
        var actif = document.activeElement;
        var perdu = !actif || actif === document.body || !!actif.closest("dialog:not([open])");
        if (perdu && opts.retour) opts.retour();
      });
      /* Clic sur le voile : la cible est le <dialog> lui-meme, que le panneau
         remplit entierement. Appui et relachement doivent y tomber tous les
         deux, sinon une selection de texte qui deborde fermerait la fenetre. */
      d.addEventListener("pointerdown", function (e) { appuiSurVoile = e.target === d; });
      d.addEventListener("click", function (e) {
        if (appuiSurVoile && e.target === d) d.close();
        appuiSurVoile = false;
      });
      d.querySelectorAll("[data-kc-pop-close]").forEach(function (b) {
        b.addEventListener("click", function () { d.close(); });
      });
    });

    function dejaVues() {
      try { return window.sessionStorage.getItem("kc-suggest") === "1"; } catch (e) { return false; }
    }
    function marquerVues() {
      try { window.sessionStorage.setItem("kc-suggest", "1"); } catch (e) { /* stockage bloque : tant pis */ }
    }

    /* Demandees des l'ajout pour etre pretes au clic : les produits
       complementaires (app Search & Discovery), sinon la meme extension.
       La premiere adresse qui propose quelque chose l'emporte. Rien de pret
       au moment du clic : on laisse partir, jamais d'attente. */
    function preparer() {
      pret = null;
      if (!sugg || dejaVues()) return;
      var n = ++demande;
      var racine = kcRacine();
      var produit = encodeURIComponent(sugg.getAttribute("data-kc-product") || "");
      var tag = sugg.getAttribute("data-kc-set");
      var adresses = [racine + "recommendations/products?product_id=" + produit +
        "&limit=10&intent=complementary&section_id=cart-suggestions"];
      if (tag) adresses.push(racine + "collections/all/" + encodeURIComponent(tag) + "?section_id=cart-suggestions");

      Promise.all(adresses.map(function (u) {
        return fetch(u)
          .then(function (r) { return r.ok ? r.text() : ""; })
          .catch(function () { return ""; });
      })).then(function (pages) {
        if (n !== demande) return;
        for (var i = 0; i < pages.length; i++) {
          var src = pages[i] && kcExtraire(pages[i], "[data-kc-suggest-src]");
          if (src && src.querySelector("[data-kc-suggest-item]")) { pret = src; return; }
        }
      });
    }

    function montrerSuggestions() {
      sugg.querySelector("[data-kc-pop-heading]").replaceChildren(pret.querySelector("[data-kc-suggest-heading]"));
      sugg.querySelector("[data-kc-pop-slot]").replaceChildren(pret.querySelector("[data-kc-suggest-list]"));
      var resume = slot.querySelector("[data-kc-pop-summary]");
      var zone = sugg.querySelector("[data-kc-pop-summary-slot]");
      zone.replaceChildren();
      if (resume) zone.appendChild(resume.cloneNode(true));
      var suite = sugg.querySelector("[data-kc-pop-continue]");
      suite.textContent = suite.getAttribute(cap === "checkout" ? "data-label-checkout" : "data-label-cart");
      pret = null;

      /* Relais d'une fenetre a l'autre sans que le voile clignote */
      ajout.classList.add("kc-pop--relay-out");
      sugg.classList.add("kc-pop--relay-in");
      ajout.close();
      ouvrir(sugg);
      setTimeout(function () {
        ajout.classList.remove("kc-pop--relay-out");
        sugg.classList.remove("kc-pop--relay-in");
      }, 450);
    }

    ajout.querySelectorAll("[data-kc-pop-go]").forEach(function (el) {
      el.addEventListener("click", function (e) {
        if (!pret || !sugg) return;
        e.preventDefault();
        cap = el.getAttribute("data-kc-pop-go");
        marquerVues();
        montrerSuggestions();
      });
    });

    if (sugg) {
      var suite = sugg.querySelector("[data-kc-pop-continue]");
      var annonce = sugg.querySelector("[data-kc-pop-live]");

      suite.addEventListener("click", function () {
        if (cap === "checkout") {
          var f = ajout.querySelector("[data-kc-pop-checkout]");
          var b = f && f.querySelector("[name='checkout']");
          if (f && b && f.requestSubmit) f.requestSubmit(b);
          else window.location.href = kcRacine() + "checkout";
        } else {
          window.location.href = ajout.querySelector("[data-kc-pop-go='cart']").href;
        }
      });

      sugg.addEventListener("submit", function (e) {
        var f = e.target.closest ? e.target.closest("[data-kc-suggest-form]") : null;
        if (!f) return;
        e.preventDefault();
        var b = f.querySelector("button[type='submit']");
        var etat = b.getAttribute("data-state");
        if (etat === "busy" || etat === "done") return;

        var ligne = f.closest("[data-kc-suggest-item]");
        var erreur = ligne && ligne.querySelector(".kc-suggest__err");
        if (erreur) erreur.remove();
        /* aria-disabled et non disabled : desactiver le bouton qui a le
           focus le renverrait hors de la fenetre. */
        b.setAttribute("data-state", "busy");
        b.setAttribute("aria-disabled", "true");

        var corps = new URLSearchParams(new FormData(f));
        corps.append("sections", "cart-popup");
        corps.append("sections_url", window.location.pathname);

        fetch(kcRacine() + "cart/add.js", {
          method: "POST",
          headers: { Accept: "application/json" },
          body: corps
        })
          .then(function (r) {
            return r.json().then(function (d) {
              if (!r.ok) throw new Error(d.description || d.message || "");
              return d;
            });
          })
          .then(function (d) {
            b.setAttribute("data-state", "done");
            b.querySelector("[data-kc-suggest-label]").innerHTML =
              KC_COCHE + (opts.textes.kcAdded || "").toUpperCase();
            if (annonce) annonce.textContent = opts.textes.kcAddedNote || "";

            var src = d.sections && d.sections["cart-popup"] &&
              kcExtraire(d.sections["cart-popup"], "[data-kc-pop-src]");
            if (src) {
              var neuf = src.querySelector("[data-kc-pop-summary]");
              if (neuf) sugg.querySelector("[data-kc-pop-summary-slot]").replaceChildren(neuf);
              opts.encaisser(src.getAttribute("data-kc-count"));
            } else {
              fetch("/cart.js", { headers: { Accept: "application/json" } })
                .then(function (r) { return r.json(); })
                .then(function (panier) { opts.encaisser(panier.item_count); })
                .catch(function () {});
            }
          })
          .catch(function (err) {
            b.removeAttribute("data-state");
            b.removeAttribute("aria-disabled");
            if (!ligne) return;
            var p = document.createElement("p");
            p.className = "kc-suggest__err";
            p.setAttribute("role", "alert");
            p.textContent = err.message || opts.textes.kcAddError || "";
            ligne.appendChild(p);
          });
      });
    }

    return {
      /* Ouvre la confirmation sur la ligne `cle`. Faux si la section ne la
         contient pas : l'appelant se rabat alors sur la note sous le bouton. */
      afficher: function (src, cle) {
        var trouvee = false;
        src.querySelectorAll("[data-kc-line]").forEach(function (l) {
          var elle = l.getAttribute("data-kc-line") === String(cle);
          l.hidden = !elle;
          if (elle) trouvee = true;
        });
        if (!trouvee) return false;
        slot.replaceChildren();
        while (src.firstChild) slot.appendChild(src.firstChild);
        if (sugg && sugg.open) sugg.close();
        if (!ajout.open) ouvrir(ajout);
        preparer();
        return true;
      }
    };
  }

  function initAddToCart() {
    var form = document.querySelector("#kc-product-form");
    /* garde : l'editeur de theme relance init() a chaque section rechargee,
       et un second ecouteur ajouterait l'article deux fois */
    if (!form || !window.fetch || form.dataset.kcAddReady) return;

    var bouton = form.querySelector("[name='add']");
    var note = form.querySelector("[data-kc-add-note]");
    var message = form.querySelector("[data-kc-add-msg]");
    var lienPanier = form.querySelector("[data-kc-add-link]");
    var pastille = document.querySelector("[data-kc-cart-link]");
    var compteur = document.querySelector("[data-kc-cart-count]");
    if (!bouton || !note) return;
    form.dataset.kcAddReady = "1";

    var libelleInitial = bouton.innerHTML;
    var textes = note.dataset;
    var champQte = form.querySelector("[name='quantity']");
    var minuteur;
    var fenetres = initCartPopups({ encaisser: encaisser, retour: reprendreFocus, textes: textes });

    /* Retour de focus apres une fenetre : le bouton d'ajout ; s'il est
       desactive (tout le stock est au panier), la note qui le dit. */
    function reprendreFocus() {
      if (!bouton.disabled) return bouton.focus();
      var cible = note.hidden ? form : note;
      if (!cible.hasAttribute("tabindex")) cible.setAttribute("tabindex", "-1");
      cible.focus();
    }

    /* Le `max` du champ vaut le stock total ; il ignore ce qui est deja au
       panier. Sans ca on peut recliquer « Ajouter » indefiniment et n'etre
       arrete qu'au moment ou Shopify refuse. On retranche donc le panier. */
    function majDisponible() {
      var stock = parseInt(textes.kcStock, 10);
      if (isNaN(stock) || !champQte) return Promise.resolve();
      return fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (panier) {
          var deja = 0;
          (panier.items || []).forEach(function (l) {
            if (String(l.id) === String(textes.kcVariant)) deja += l.quantity;
          });
          var reste = Math.max(0, stock - deja);
          champQte.max = reste;
          if (parseInt(champQte.value, 10) > reste) champQte.value = Math.max(1, reste);
          champQte.dispatchEvent(new Event("input", { bubbles: true }));
          if (reste === 0) {
            bouton.disabled = true;
            bouton.setAttribute("aria-disabled", "true");
            /* Ne le dire que si le panier en est vraiment la cause. A stock
               nul et panier vide, reste vaut zero lui aussi, et annoncer que
               l'article est deja au panier serait faux : le badge EPUISE et
               le bouton desactive disent alors tout ce qu'il y a a dire. */
            if (deja > 0) dire(textes.kcMaxReached || "", false);
          }
        })
        .catch(function () { /* panier illisible : on laisse Shopify trancher */ });
    }

    function dire(texte, estErreur) {
      message.textContent = texte;
      note.hidden = false;
      note.classList.toggle("kc-addnote--erreur", !!estErreur);
      if (lienPanier) lienPanier.hidden = !!estErreur;
    }

    function repos() {
      bouton.innerHTML = libelleInitial;
      bouton.removeAttribute("data-kc-state");
      bouton.disabled = false;
    }

    /* Le compteur bascule au creux de l'animation, pas a son debut :
       le chiffre change au moment ou la pastille encaisse. */
    function encaisser(total) {
      if (!pastille || !compteur) return;
      pastille.classList.remove("is-received");
      void pastille.offsetWidth;                  // relance l'animation
      pastille.classList.add("is-received");
      compteur.classList.remove("is-tick");
      void compteur.offsetWidth;
      compteur.classList.add("is-tick");
      setTimeout(function () { compteur.textContent = total; }, 130);
      /* Retrait au minuteur et non sur animationend : en mouvement reduit
         l'animation dure 0 et l'etat de confirmation disparaitrait aussitot. */
      setTimeout(function () {
        pastille.classList.remove("is-received");
        compteur.classList.remove("is-tick");
      }, 700);
    }

    majDisponible();

    form.addEventListener("submit", function (e) {
      if (bouton.disabled) return;
      e.preventDefault();
      clearTimeout(minuteur);

      bouton.disabled = true;
      bouton.setAttribute("data-kc-state", "envoi");
      note.hidden = true;

      var corps = new URLSearchParams(new FormData(form));   // url-encode : plus leger que multipart
      /* Rendu groupe : Shopify renvoie avec l'ajout la section de la
         fenetre, rendue sur le panier deja a jour. Un seul aller-retour. */
      if (fenetres) {
        corps.append("sections", "cart-popup");
        corps.append("sections_url", window.location.pathname);
      }

      fetch("/cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: corps
      })
        .then(function (r) {
          return r.json().then(function (d) {
            if (!r.ok) throw new Error(d.description || d.message || "");
            return d;
          });
        })
        .then(function (ligne) {
          var html = fenetres && ligne.sections && ligne.sections["cart-popup"];
          var src = html ? kcExtraire(html, "[data-kc-pop-src]") : null;
          if (src) return { ligne: ligne, src: src, total: src.getAttribute("data-kc-count") };
          return fetch("/cart.js", { headers: { Accept: "application/json" } })
            .then(function (r) { return r.json(); })
            .then(function (panier) { return { ligne: ligne, total: panier.item_count }; });
        })
        .then(function (res) {
          encaisser(res.total);
          bouton.setAttribute("data-kc-state", "ok");
          bouton.innerHTML = KC_COCHE + "<span>" + (textes.kcAdded || "") + "</span>";
          if (res.src && fenetres.afficher(res.src, res.ligne.key)) {
            /* la fenetre confirme ; le bouton reste actif pour que le focus
               puisse y revenir quand elle se ferme */
            bouton.disabled = false;
          } else {
            dire(textes.kcAddedNote || "", false);
          }
          minuteur = setTimeout(function () { repos(); majDisponible(); }, 2200);
        })
        .catch(function (err) {
          repos();
          dire(err.message || textes.kcAddError || "", true);
        });
    });
  }

  /* Calendrier des sorties : Liquid calcule le compte à rebours de la
     prochaine sortie ; on le refait ici au jour près, en heure locale, pour
     qu'une page servie depuis le cache ne reste pas en retard d'un jour. */
  function initCalendrier() {
    document.querySelectorAll("[data-kc-sortie]").forEach(function (el) {
      var p = (el.dataset.kcSortie || "").split("-");
      var court = el.querySelector("[data-kc-compte-court]");
      var long = el.querySelector("[data-kc-compte-long]");
      if (p.length !== 3 || !court || !long) return;
      var cible = new Date(+p[0], +p[1] - 1, +p[2]);
      var auj = new Date();
      auj.setHours(0, 0, 0, 0);
      var jours = Math.round((cible - auj) / 864e5);   /* arrondi : les jours de 23 h et 25 h du changement d'heure */
      if (isNaN(jours)) return;
      if (jours > 1) {
        court.textContent = el.dataset.kcCourt.replace("#", jours);
        court.setAttribute("aria-hidden", "true");
        long.textContent = el.dataset.kcLong.replace("#", jours);
        long.className = "kc-visually-hidden";
        long.hidden = false;
      } else {
        court.textContent = jours === 1 ? el.dataset.kcDemain : el.dataset.kcAujourdhui;
        court.removeAttribute("aria-hidden");
        long.hidden = true;
      }
    });
  }

  function init() {
    initBurger();
    initAddressCountry();
    initQty(document);
    initCartAutoSubmit();
    initCartStock(document);
    initGallery();
    initCountdown();
    initCalendrier();
    initSeriesLight();
    initTabs();
    initAlertPrefs();
    initBooster();
    initFiltres();
    initPredictiveSearch();
    initCookieBanner();
    initAddToCart();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  /* Re-init après un rendu de section dans l'éditeur de thème */
  document.addEventListener("shopify:section:load", function () { init(); });
})();
